import Vue from 'vue'
import App from './App.vue'
import router from './router' // ✅ 引入 router
import websocket from './utils/websocket'

Vue.config.productionTip = false

// 启动 WebSocket 连接
websocket.connect()
Vue.prototype.$ws = websocket

new Vue({
  router, // ✅ 挂载 router
  render: h => h(App),
}).$mount('#app')
